export const SUMMARY_PANEL_TEST_ID = 'SummaryPanel';
